interface ConfirmValueComponentContextInterface extends ContextInterface {
    element: HTMLInputElement;
}

export default class ConfirmValueComponent {
    readonly #context: ConfirmValueComponentContextInterface;

    constructor(context: ConfirmValueComponentContextInterface) {
        this.#context = context;
    }

    public onInit(): void {
        const targetName = this.#context.element
            .getAttribute('data-value-confirm-name')
            ?.replace('second', 'first');
        const target: HTMLInputElement | null = document.querySelector(
            `[data-value-confirm-name="${targetName}"]`
        );

        if (target === null) {
            return;
        }

        ['input', 'propertychange', 'change'].forEach((event) => {
            this.#context.element.addEventListener(event, () => {
                this.#validate(target);
            });
        });

        this.#context.element.addEventListener('paste', (e) => {
            e.preventDefault();
        });

        const form = this.#context.element.closest('form');
        if (form) {
            form.addEventListener('submit', (e) => {
                e.preventDefault();

                if (this.#validate(target, form)) {
                    form.submit();
                }
            });
        }
    }

    #validate(target: HTMLInputElement, form?: HTMLFormElement): boolean {
        if (this.#context.element.value !== target.value) {
            this.#context.element.setCustomValidity(this.#context.bindings.message);
            if (form) {
                form.submit();
            }
            return false;
        }

        this.#context.element.setCustomValidity('');

        return true;
    }

    static getClassName(): string {
        return 'ConfirmValueComponent';
    }
}
